export class DepartmentUsersIDRequestModel
{
    UsersIDs:number[]=[]
    DepartmentId:number;

}